module.exports = __webpack_public_path__ + "img/img-slogan@1x.89219f1a.png";